import type { Config } from 'dompurify';

export const JIRA_SANITIZE_OPTIONS: Config = {
  ADD_TAGS: ['video', 'source', 'audio', 'details', 'summary', 'time'],
  ADD_DATA_URI_TAGS: ['img', 'video', 'source'],
  ADD_ATTR: [
    'controls',
    'data-media-id',
    'target',
    'rel',
    'colspan',
    'rowspan',
    'src',
  ],
  FORCE_BODY: true,
  ALLOWED_URI_REGEXP:
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
};
